import React, { useCallback } from 'react';
import {
  FormProps,
  Form as CustomForm,
} from '../../../../components/form/Form';
import { FieldValues } from 'react-hook-form';
import { collectFormDataExtraFields } from './logic';
import { useExtraFieldsFormValidationByFormId } from './useExtraFieldsFormValidation';
import {
  ExtraFieldContextParam,
  ExtraFieldsFormId,
  ExtraFieldsSupportedObject,
} from './types';
import { ExtraFieldInternalValue } from './extraFieldInternalValue';
type Props<T extends FieldValues> = Omit<FormProps<T>, 'onSubmit'> & {
  onSubmit: (data: T, extraFields: ExtraFieldInternalValue[]) => void;
  objectApiName: ExtraFieldsSupportedObject;
  contextParams?: ExtraFieldContextParam[];
  formId: ExtraFieldsFormId;
};

export const ExtraFieldsForm = <T extends FieldValues>({
  objectApiName,
  contextParams,
  onSubmit,
  validationSchema,
  formId,
  defaultValues: propsDefaultValues,
  ...restProps
}: Props<T>) => {
  const { applyExtraFieldsValidationSchema } =
    useExtraFieldsFormValidationByFormId({
      objectApiName,
      formId,
      contextParams: contextParams ?? [],
    });

  const handleSubmit = useCallback(
    (formData: T) => {
      const extraFields = collectFormDataExtraFields(formData);
      return onSubmit(formData, extraFields);
    },
    [onSubmit],
  );

  const combinedValidationSchema = validationSchema
    ? applyExtraFieldsValidationSchema(validationSchema)
    : undefined;

  return (
    <CustomForm
      onSubmit={handleSubmit}
      defaultValues={propsDefaultValues}
      validationSchema={combinedValidationSchema}
      {...restProps}></CustomForm>
  );
};
